"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var material_2 = require("@mui/material");
var CheckCircle_1 = __importDefault(require("@mui/icons-material/CheckCircle"));
var Warning_1 = __importDefault(require("@mui/icons-material/Warning"));
var Close_1 = __importDefault(require("@mui/icons-material/Close"));
require("../../scss/_snackbar.scss");
/**
 * @component Snackbar
 * @example
 * return (
 *   <Snackbar
 *      open={applicationStatus.showMessage}
 *      message={applicationStatus.message}
 *      type={applicationStatus.messageType}
 *      onClose={handleCloseSnackbar}
 *   />
 * )
 *
 * @param {boolean} open if the snackbar is open or closed
 * @param {string} message message to display on the snackbar
 * @param {string} type possible values can be one of: "error" | "success";
 * @param {function} onClose function to close the snackbar
 * @param {boolean} autoHide whether to hide the snackbar automatically, currently always true
 * @param {number} autoHideDuration how long to wait until we hide the snackbar, default value is 5s
 */
var Snackbar = function (props) {
    var _a = props.open, open = _a === void 0 ? false : _a, message = props.message, type = props.type, onClose = props.onClose, _b = props.autoHideDuration, autoHideDuration = _b === void 0 ? 5000 : _b;
    var contentHtml = (react_1.default.createElement(material_2.Grid, { container: true, justifyContent: "space-between", alignItems: "center" },
        react_1.default.createElement(material_2.Grid, { item: true, className: "icon" }, type === "success" ? react_1.default.createElement(CheckCircle_1.default, null) : react_1.default.createElement(Warning_1.default, null)),
        react_1.default.createElement(material_2.Grid, { item: true, xs: true },
            react_1.default.createElement(material_2.Grid, { container: true, alignItems: "center" },
                react_1.default.createElement(material_2.Grid, null,
                    react_1.default.createElement(material_2.Typography, { variant: "subtitle2" }, message)))),
        react_1.default.createElement(material_2.Grid, { item: true, onClick: onClose },
            react_1.default.createElement(Close_1.default, { color: "disabled" }))));
    return (react_1.default.createElement("div", { className: "snackbar ".concat(type) },
        react_1.default.createElement(material_1.Snackbar, { anchorOrigin: { vertical: "top", horizontal: "center" }, open: open, onClose: onClose, message: contentHtml, key: message, autoHideDuration: autoHideDuration })));
};
exports.default = Snackbar;
